import PhotoSearchUpgradeIOSNotice from './PhotoSearchUpgradeIOSNotice';

export default PhotoSearchUpgradeIOSNotice;
